import React, { useMemo } from 'react';
import { getLimitWarning } from 'utils';

import { Icon, Label } from '@atlas/ui';

const RenderMainStateRow = ({ future = null, prettyValue, type, value }) => {
  const futureMarkup = useMemo(() => {
    const warning = getLimitWarning(future, type);

    if (!warning || !value) return null;

    return (
      <div className="limit__warning-block">
        <Icon name="warning" />
        <Label {...warning} />
      </div>
    );
  }, [future, type, value]);

  return (
    <div className="limit">
      <div className="limit__text">
        <Label className="limit__key" message={`responsible_game_${type}_limit`} />
        <span className="limit__key">: </span>
        <span className="limit__value">
          {value ? prettyValue : <Label className="limit__value-no-set" message="no_set" />}
        </span>
      </div>
      {futureMarkup}
    </div>
  );
};

export default RenderMainStateRow;
